import qs from "qs";
import { useLocation } from "react-router-dom";

import { SearchTerm } from "@is/types";

type QueryParams = {
  t?: string;
  searchTerms?: SearchTerm[];
};

type PageParamsState = {
  tenantId?: string;
  searchTermsParams?: SearchTerm[];
};

export const usePageParams = (): PageParamsState => {
  const location = useLocation();

  const { t: tenantId, searchTerms = [] } = qs.parse(location.search, {
    ignoreQueryPrefix: true,
    arrayLimit: 100,
  }) as QueryParams;

  return { tenantId, searchTermsParams: searchTerms };
};
